"use client"

import * as React from "react"
import { Button } from "@/components/tiptap/tiptap-ui-primitive/button"
import { MoonStarIcon } from "@/components/tiptap/tiptap-icons/moon-star-icon"
import { SunIcon } from "@/components/tiptap/tiptap-icons/sun-icon"

export function ThemeToggle() {
  const [isDarkMode, setIsDarkMode] = React.useState<boolean>(() => {
    if (typeof window === "undefined") return false
    const stored = localStorage.getItem("chakra-ui-color-mode")
    return stored === "dark"
  })

  React.useEffect(() => {
    if (typeof window === "undefined") return

    document.documentElement.classList.toggle("dark", isDarkMode)
    localStorage.setItem("chakra-ui-color-mode", isDarkMode ? "dark" : "light")
  }, [isDarkMode])

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev)
  }

  return (
    <Button
      onClick={toggleDarkMode}
      aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
      data-style="ghost"
    >
      {isDarkMode ? (
        <MoonStarIcon className="tiptap-button-icon" />
      ) : (
        <SunIcon className="tiptap-button-icon" />
      )}
    </Button>
  )
}
